import { ApiError } from './api.ts';

/**
 * A failure the browser causes, not our code: a session that ended or changed
 * underneath an open tab, or a connection that dropped. Screens already handle
 * both, and reporting them buries the real faults. Unlike `isSessionRefusal`,
 * this counts an unreachable backend too.
 */
export function isExpectedApiFailure(caught: unknown): boolean {
  return (
    caught instanceof ApiError &&
    (caught.type === 'unauthorized' || caught.type === 'network')
  );
}
